var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import "./NavigationStyle.scss";
var NavigationComponent = /** @class */ (function () {
    function NavigationComponent(options) {
        this.options = __assign({ position: "fixed", id: "luxbar-checkbox", alignment: "left" }, options);
    }
    NavigationComponent.prototype.isEqual = function (node) {
        return this.__proto__ === node.__proto__;
    };
    NavigationComponent.prototype.render = function () {
        var _this = this;
        var _a, _b;
        return {
            tag: "header",
            attr: { style: this.options.style, class: "nav-comp " + ((_a = this.options.class) !== null && _a !== void 0 ? _a : "") },
            children: [
                { tag: "div", attr: { class: "luxbar luxbar-" + this.options.position },
                    children: [
                        { tag: "input", attr: { type: "checkbox", class: "luxbar-checkbox", id: this.options.id } },
                        { tag: "div", attr: { class: "luxbar-menu luxbar-menu-" + this.options.alignment + " luxbar-menu-light" },
                            children: [{ tag: "ul", attr: { class: "luxbar-navigation" }, children: __spreadArray([
                                        { tag: "li", attr: { class: "luxbar-header" }, children: [
                                                { tag: "a", attr: { href: (_b = this.options.titleLink) !== null && _b !== void 0 ? _b : "#", class: "luxbar-brand" }, children: [this.toNode(this.options.title)] },
                                                { tag: "label", attr: { class: "luxbar-hamburger luxbar-hamburger-spin", for: this.options.id },
                                                    children: [{ tag: "span" }] },
                                            ] }
                                    ], this.options.data.map(function (x) { return _this.itemToNode(x); }), true) }] }
                    ] }
            ]
        };
    };
    NavigationComponent.prototype.itemToNode = function (x) {
        var _this = this;
        var _a, _b, _c;
        return { tag: "li", attr: { class: "luxbar-item" + (((_a = x.children) === null || _a === void 0 ? void 0 : _a.length) > 0 ? " dropdown" : "") + (this.isActive(x.link) ? " active" : "") }, children: [
                { tag: "a", attr: { href: (_b = x.link) !== null && _b !== void 0 ? _b : "#", target: x.target, click: x.click }, children: [this.toNode(x.content)] },
                (((_c = x.children) === null || _c === void 0 ? void 0 : _c.length) > 0 ? { tag: "ul", children: x.children.map(function (c) { return _this.itemToNode(c); }) } : undefined)
            ] };
    };
    NavigationComponent.prototype.isActive = function (link) {
        return location.hash.startsWith(link);
    };
    NavigationComponent.prototype.toNode = function (content) {
        if (typeof content === "string") {
            return { tag: "span", content: content };
        }
        return content;
    };
    return NavigationComponent;
}());
export { NavigationComponent };
